@if (form) {
<form (ngSubmit)="onSubmit()" [formGroup]="form" align="end" novalidate>
  <mat-form-field>
    <input formControlName="search" matInput placeholder="Search" type="text" />
    @if (!isSearchDisabled) {
    <button [disabled]="!searchValue" mat-icon-button matSuffix type="submit">
      <mat-icon>search</mat-icon>
    </button>
    } @else {
    <button (click)="clearSearch()" mat-icon-button matSuffix type="button">
      <mat-icon>close</mat-icon>
    </button>
    }
  </mat-form-field>
</form>
}
